import React, { createContext, useContext, useState, useCallback } from 'react';

const ModuleContext = createContext(null);

export const useModule = () => {
  const context = useContext(ModuleContext);
  if (!context) {
    throw new Error('useModule must be used within ModuleProvider');
  }
  return context;
};

export const ModuleProvider = ({ children }) => {
  const [activeModule, setActiveModule] = useState('DOMESTIC');

  const switchModule = useCallback((mod) => {
    if (mod === 'DOMESTIC' || mod === 'INTERNATIONAL') {
      setActiveModule(mod);
    }
  }, []);

  const isDomestic = activeModule === 'DOMESTIC';
  const isInternational = activeModule === 'INTERNATIONAL';
  const currencySymbol = isDomestic ? 'INR' : 'USD';
  const defaultCurrency = isDomestic ? 'INR' : 'USD';
  const tripType = isDomestic ? 'Domestic' : 'International';

  return (
    <ModuleContext.Provider value={{
      activeModule,
      switchModule,
      isDomestic,
      isInternational,
      currencySymbol,
      defaultCurrency,
      tripType
    }}>
      {children}
    </ModuleContext.Provider>
  );
};
